import { render, staticRenderFns } from "./LangDropdown.vue?vue&type=template&id=dfd761b6&scoped=true&"
import script from "./LangDropdown.vue?vue&type=script&lang=ts&"
export * from "./LangDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./LangDropdown.vue?vue&type=style&index=0&id=dfd761b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd761b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
